module.exports = __webpack_public_path__ + "img/calligraphy-test-icon2.5ab4d9af.jpg";